import { render } from "./ReferralProgramPage.vue?vue&type=template&id=75d6e75c&scoped=true"
import script from "./ReferralProgramPage.vue?vue&type=script&lang=js"
export * from "./ReferralProgramPage.vue?vue&type=script&lang=js"

import "./ReferralProgramPage.vue?vue&type=style&index=0&id=75d6e75c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d6e75c"]])

export default __exports__